/* eslint-disable no-shadow */
/**
 * Action types
 * @UPDATE_USER update user infos
 * @REMOVE_USER remove user infos
 */
export enum AuthTypes {
  LOGIN = '@Kumon/LOGIN',
  LOGOUT = '@Kumon/LOGOUT',
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  PERSIST_REHYDRATE = 'persist/REHYDRATE',
}

/**
 * State type
 * @data : the constructionCompany
 */
export interface AuthState {
  token: string;
  isLoggedIn: boolean;
}
